import { HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

// export const baseURL = "https://tracker.primeservicescro.com/api/";
// export const baseURL = "http://localhost:8090/";
export const baseURL = environment.apiUrl;

export const VERSION = "v1";
export const TIMESHEET_STATUS_VERIFIED = "Are you sure you want to change the status to verified?";
export const TIMESHEET_STATUS_UN_VERIFIED = "Are you sure you want to change the status to un-verified?";
export const TIMESHEET_STATUS_ALL_VERIFIED = "Are you sure you want to change all status to verified?";
export const TIMESHEET_STATUS_ALL_UN_VERIFIED = "Are you sure you want to change all status to un-verified?";
export const TIMESHEET_STATUS = [
    {id:0,name:"Unverified"},
    {id:1,name:"Verified"},
    {id:2,name:"Partially Verified"},
    {id:3,name:"Incomplete"},
    {id:4,name:"Missed"}
]
export function getHeaders(): { headers: HttpHeaders } {
    const authToken = sessionStorage.getItem('authToken');
    let headers = new HttpHeaders();
    if (authToken) {
        headers = headers.set('Authorization', `Bearer ${authToken}`);
    }
    headers = headers.set('Content-Type', 'application/json'); 
    return { headers };
}
export const PAGE_SIZE_OPTIONS : number[] = [5, 10, 25, 100];